import { Link } from "react-router-dom";
import { ADMIN_BASE } from "../lib/paths.js";
import { Empty } from "../components/Empty.js";

export function NotFound(): JSX.Element {
  return (
    <Empty
      title="页面不存在"
      description="请检查 URL，或返回概览。"
      action={
        <Link
          to={ADMIN_BASE}
          className="rounded border border-dosia-border px-3 py-1 text-sm text-dosia-text hover:bg-dosia-bg-lighter"
        >
          回到概览
        </Link>
      }
    />
  );
}
